import { AWStageDto } from '@api/Api';
import { timeList } from '@components/DatePickerComponent/timeList';
import moment from 'moment';

type GetNearestTimeProps = {
  selectedTimeKey: string | undefined;
  date: moment.Moment | null;
  disabledTime: ((date: moment.Moment) => boolean) | undefined;
};
function getNearestTime({
  selectedTimeKey,
  date,
  disabledTime
}: GetNearestTimeProps) {
  if (!disabledTime) return;
  const time = moment(date ?? moment());
  if (!disabledTime(time)) return;
  const nearestTimeItem = timeList.filter((x) => {
    if (x.id === selectedTimeKey) return true;
    time.endOf('minute');
    time.hours(x.hours);
    time.minutes(x.minutes);
    return !disabledTime(time);
  })[1];
  return nearestTimeItem;
}

type GetValidDeadlineTimeForStage = {
  stages: AWStageDto[];
  stage: AWStageDto;
  v: moment.Moment;
};

export default function getValidDeadlineTimeForStage({
  stages,
  stage,
  v
}: GetValidDeadlineTimeForStage) {
  const stagesLength = stages.length;
  const lastStageIndex = stagesLength - 1;
  let currentStageIndex = stages.findIndex((it) => it.id === stage.id);
  const stagesWithSameDate = stages.filter(
    (it, idx) =>
      currentStageIndex !== idx && v.isSame(moment(it.deadline).local(), 'day')
  );

  const stagesWithSameDateWithCurrent = stages.filter((it, idx) =>
    v.isSame(moment(it.deadline).local(), 'day')
  );

  currentStageIndex = stagesWithSameDateWithCurrent.findIndex(
    (it) => it.id === stage.id
  );

  if (!stagesWithSameDate.length) return v.isBefore(moment().local());

  if (currentStageIndex === 0) {
    const nearestNextTime = stagesWithSameDate.find(
      (it) => it.deadline
    )?.deadline;

    return !v.isBetween(
      moment().local(),
      moment(nearestNextTime).local(),
      undefined,
      '[]'
    );
  }

  if (currentStageIndex === lastStageIndex) {
    const nearestPrevTime = stagesWithSameDate
      .reverse()
      .find((it) => it.deadline)?.deadline;

    return !v.isBetween(
      moment(nearestPrevTime).local(),
      moment(stage.deadline).endOf('day').local(),
      undefined,
      '[)'
    );
  }

  if (currentStageIndex > 0 && currentStageIndex < lastStageIndex) {
    const prevDates = stagesWithSameDateWithCurrent.slice(0, currentStageIndex);
    const nextDates = stagesWithSameDateWithCurrent.slice(
      currentStageIndex + 1
    );
    const nearestPrevDate = prevDates.at(-1);
    const nearestNextDate = nextDates.at(0);

    if (!nearestNextDate) {
      return v.isBefore(moment(nearestPrevDate?.deadline).local());
    }
    return !v.isBetween(
      moment(nearestPrevDate?.deadline).local(),
      moment(nearestNextDate.deadline).local(),
      undefined,
      '[]'
    );
  }

  return v.isBefore(moment().local());
}
